<fuse-loading-bar></fuse-loading-bar>
<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (layout() === 'empty') {
  <app-empty-layout></app-empty-layout>
}
<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with vertical navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Dense -->
@if (layout() === 'dense') {
  <app-dense-layout></app-dense-layout>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
